import React from "react";
import styled from "styled-components";
import {
  getAlimtalkStatus,
  getKakaoStatus,
  getSmsStatus,
} from "../../../../AdminApi/commFunc";

interface StatusCodeBoxProps {
  status?: {
    kakao?: string;
    sms: string;
    api: string;
  };
}

export default function StatusCodeBox({ status }: StatusCodeBoxProps) {
  return (
    <>
      <StatusCodeBoxContainer>
        status : {status?.api}_
        {getAlimtalkStatus(Number(status?.api?.split("_")[1]))?.type}
        {status?.kakao ? <br /> : null}
        {status?.kakao
          ? `kakao_status: ${status?.kakao}_${
              getKakaoStatus(`${status?.kakao}`)?.desc
            }`
          : ""}
        {status?.sms ? <br /> : null}
        {status?.sms
          ? `sms_status: ${status?.sms}_${
              getSmsStatus(Number(status?.sms))?.desc
            }`
          : ""}
      </StatusCodeBoxContainer>
    </>
  );
}

export const StatusCodeBoxContainer = styled.div`
  height: auto;
  margin-bottom: 76px;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 16px;
  border-radius: 3px;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray500};
`;
